<template>
  <HomeLayout>
    <b-row class="on-ground-container" :class="wrapperClass">
      <!--PRODUCT SPECIFIC PANELS-->
      <b-col
        v-for="(data, index) in thePanels.productSpecific"
        :key="'p' + index"
        class="column-border card-col col-12"
        :class="columnClass"
      >
        <a class="vtd-card vtd-animate-shake" @click="handleProductClick(data)">
          <div class="navigation-block">
            <h4 class="nav-title-center text-uppercase">
              {{ data.productTitle }}
            </h4>
            <h4 class="nav-title-center" v-if="data.subHeading">
              ({{ data.subHeading }})
            </h4>
            <p v-if="data.showDate" class="text-center">
              {{ data.groupDate }}
            </p>

            <div class="nav-text-center">
              <i
                v-if="data.productType !== 'tour'"
                :class="`icon-${getIcon(data.productType)} vtd-icon-7`"
              />
              <TourIcon
                v-if="data.productType === 'tour'"
                :brick-id="data.brickId"
                :tour-type="data.tourType"
              />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </a>
      </b-col>

      <!-- DESTINATION ADVICE PANEL-->
      <b-col
        class="column-border card-col col-12"
        :class="columnClass"
      >
        <a
          class="vtd-card vtd-animate-shake"
          @click="openDestinationAdviceModal()"
        >
          <div class="navigation-block">
            <h4 class="nav-title-center">DESTINATION ADVICE</h4>
            <div class="nav-text-center">
              <!-- <i class="icon-on_the_ground vtd-icon-7"/> -->
              <i class="material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle d-advice-icon vtd-icon-7 nav-dest-advice-icon">
            <span>language</span>
          </i>
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </a>
      </b-col>

      <!--GENERAL PANEL-->
      <b-col
        v-if="thePanels.general.length"
        class="column-border card-col col-12"
        :class="columnClass"
      >
        <a
          class="vtd-card vtd-animate-shake"
          @click="openGeneralModal(thePanels.general)"
        >
          <div class="navigation-block">
            <h4 class="nav-title-center">GENERAL</h4>
            <div class="nav-text-center">
              <i class="icon-on_the_ground vtd-icon-7"/>
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </a>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="home-nav-container-header text-center" style="height: auto">
        <p class="my-3">
          If additional information relating to any of your arrangements is
          applicable, the links will appear here.<br />
          Please note that not all arrangements will have additional
          information.
        </p>
      </b-col>
    </b-row>
    <GroundGeneralModal ref="GroundGeneralModalRef" />
    <GroundProductModal ref="GroundProductModalRef" />
    <DestinationAdviceModal ref="DestinationAdviceModalRef" />
    <HomeBackBtns />
  </HomeLayout>
</template>

<script>
import HomeLayout from "@/partials/home-layout";
import TourIcon from "@/partials/tour-icon";
import GroundGeneralModal from "@/modules/navigation/modals/ground-general-modal";
import GroundProductModal from "@/modules/navigation/modals/ground-product-modal";
import DestinationAdviceModal from "../../../../partials/destination-advice/modals/destination-advice-modal.vue";
import {
  fetchSupplierRecord,
  fetchDestinationRecord,
  fetchCheckInRecord,
} from "@/partials/extra-info-buttons/services.js";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    HomeLayout,
    TourIcon,
    GroundGeneralModal,
    GroundProductModal,
    DestinationAdviceModal,
  },
  data() {
    return {
      thePanels: {
        general: [],
        health: [],
        productSpecific: [],
      },
      productDupeCheck: [],
      iconsMap: {
        hotel: "accomodation",
        tour: "local_tour",
        transfer: "transfer",
        vehicle: "car_hire",
        rail: "rail",
      },
      wrapperClass: "",
      columnClass: "",
    };
  },
  computed: {
    ...mapGetters({
      essentialInfoMenu: "essentialInfoMenu/getMenu",
      itineraryRaw: "booking/getItineraryRaw",
      sessionNum: "booking/getSessionID",
    }),
  },
  watch: {
    itineraryRaw: async function () {
      await this.renderPanels();
    },
  },
  async created() {
    await this.renderPanels();
  },
  methods: {
    ...mapActions({
      setProductSpecific: "navigation/setProductSpecificAction",
    }),
    setColumnClass(n) {
      if (n === 1) {
        this.wrapperClass = "justify-content-center";
        this.columnClass = "col-lg-4";
      }
      if (n > 1 && n <= 5) {
        this.columnClass = "col-lg";
      }
      if (n > 5 && n <= 6) {
        this.columnClass = "col-lg-4";
      }
      if (n >= 7 && n <= 8) {
        this.columnClass = "col-lg-3";
      }
      if (n >= 9) {
        this.columnClass = "col-lg-5th";
      }
    },
    async renderPanels() {
      const panels = {
        general: [],
        productSpecific: [],
      };
      // general info from essential info menu
      const essMenu =
        this.essentialInfoMenu.filter((el) =>
          [
            "Accommodation",
            "Tour / Cruise",
            "General Information",
            "Health & Safety",
          ].includes(el.title)
        ) || null;

      if (essMenu && essMenu.length) {
        essMenu.forEach((el) => {
          if (el.partial && el.title) {
            panels.general.push(el);
          }
          if (el.submenu && el.submenu.length) {
            el.submenu.forEach((sub) => {
              panels.general.push(sub);
            });
          }
        });
      }
      // product specific from itinerary
      if (this.itineraryRaw && this.itineraryRaw.itinerary.length) {
        for (const day of this.itineraryRaw.itinerary) {
          const products = day.data.filter(
            (el) =>
              el.essentialInformation &&
              el.statusonrecord !== "UNABLE TO CONFIRM" &&
              (el.essentialInformation.productEssential.length > 0 ||
                el.essentialInformation.checkInEssential.length > 0)
          );
          if (products.length) {
            for (const data of products) {
              let panel = {
                id: data.jsonid,
                productType: data.jsontype,
                productTitle: "",
                tourType: "",
                brickId: "",
                supplier: data.supplier,
                groupDate: data.groupdate,
                showDate: false,
                essentialInfoData: [],
                subHeading: ''
              };
              if (data.jsontype === "hotel") {
                panel.productTitle = data.suppliername;
              }
              if (data.tourhubtype) {
                panel.productTitle = 'PRIVATE TOUR'
                panel.subHeading = `with ${data.operator}`
              } 
              if (data.jsontype === "tour" && !data.tourhubtype) {
                panel.tourType = data.tourtype;
                panel.brickId = data.brickid;
                if (data.tourtype === "LOCAL TOUR") {
                  panel.productTitle = data.tourname;
                } else {
                  panel.productTitle = data.operator;
                }
              }
              if (data.jsontype === "vehicle") {
                panel.productTitle = data.suppliername;
              }
              if (data.jsontype === "transfer") {
                panel.productTitle = data.operator;
              }
              if (data.jsontype === "rail") {
                panel.productTitle = data.operator;
              }

              // productEssential
              for (const info of data.essentialInformation.productEssential) {
                const essentialInfoData = {
                  id: info._id,
                  infoType: "",
                  productType: data.jsontype,
                  tourType: panel.tourType,
                  accordions: [],
                  groupDate: panel.groupDate,
                };
                // get product/destination data here to exclude duplicates
                if (info.suppliers) {
                  essentialInfoData.infoType = "product";
                  const sup = await fetchSupplierRecord(
                    essentialInfoData.id,
                    this.sessionNum
                  );
                  if (sup.accordions && sup.accordions.length) {
                    essentialInfoData.accordions = sup.accordions;
                  }
                }
                if (info.destinations) {
                  essentialInfoData.infoType = "destination";
                  const dest = await fetchDestinationRecord(
                    essentialInfoData.id,
                    this.sessionNum
                  );
                  if (dest.accordions && dest.accordions.length) {
                    essentialInfoData.accordions = dest.accordions;
                  }
                }
                // check for dupe supplier/operator/id
                const suppl = this.productDupeCheck.find((el) => {
                  return (
                    el.supplier === data.supplier &&
                    el.operator === data.operator &&
                    el.id === essentialInfoData.id
                  );
                });
                if (!suppl) {
                  // not a dupe so add it
                  panel.essentialInfoData.push(essentialInfoData);
                } else {
                  // same supplier but check id and date
                  if (essentialInfoData.id !== suppl.id) {
                    // if date is different we need to show it
                    if (essentialInfoData.groupDate !== suppl.groupDate) {
                      panel.showDate = true;
                    }
                    panel.essentialInfoData.push(essentialInfoData);
                  }
                }
                this.productDupeCheck.push({
                  id: essentialInfoData.id,
                  supplier: data.supplier,
                  operator: data.operator,
                  groupDate: data.groupdate,
                });
              }

              // checkIn Essentials
              for (const info of data.essentialInformation.checkInEssential) {
                const checkinData = {
                  id: info._id,
                  infoType: "checkin",
                  productType: data.jsontype,
                  accordions: [],
                };
                const ch = await fetchCheckInRecord(
                  checkinData.id,
                  this.sessionNum
                );
                if (ch.cardImage && ch.cardImage.length) {
                  checkinData.accordions = ch.cardImage;
                  panel.essentialInfoData.push(checkinData);
                }
              }

              if (panel.essentialInfoData.length) {
                // update date flag for ALL panels for this supplier
                if (panel.showDate) {
                  const tmpPanels = panels.productSpecific.map((tmp) => {
                    if (tmp.supplier === panel.supplier) {
                      tmp.showDate = true;
                    }
                    return tmp;
                  });
                  panels.productSpecific = tmpPanels;
                }
                panels.productSpecific.push(panel);
              }
            }
          }
        }
      }
      const totalPanels =
        (panels.general.length ? 1 : 0) + panels.productSpecific.length;
      this.setColumnClass(totalPanels);
      this.thePanels = panels;
      this.setProductSpecific(panels.productSpecific);
    },
    openGeneralModal(payload) {
      this.$refs.GroundGeneralModalRef.showModal(payload);
    },
    openDestinationAdviceModal() {
      this.$refs.DestinationAdviceModalRef.showDestinationAdviceModal()
    },
    async handleProductClick(data) {
      if (data.essentialInfoData.length === 1) {
        await this.$refs.GroundProductModalRef.showModal(
          data.essentialInfoData[0]
        );
      } else {
        await this.$router.push({
          name: "on-the-ground-product",
          params: { id: data.id },
        });
      }
    },
    getIcon(type) {
      let icon = "information";
      if (type && this.iconsMap[type]) {
        icon = this.iconsMap[type];
      }
      return icon;
    },
  },
};
</script>
<style lang="scss" scoped>
.on-ground-container {
  height: auto;
}
@media (min-width: 992px) {
  .col-lg-5th {
    flex: 0 0 20%;
    max-width: 20%;
  }
}
</style>
